import React from "react";
import { Link } from "react-router-dom";

const Card3 = ({ article }) => {
  return (
    <Link to={`/article/${article.slug}`}>
      <div class="w-full">
        <div class="w-full relative font-nunito  ">
          <a href="#">
            <img
              className="w-full object-fit"
              src="./img/do.png"
              alt={article.image.url}
            />
          </a>
          <div class="p-4 lg:p-5 absolute left-0 bottom-0 mx-2 lg:mx-9 lg:mb-5">
            <a href="#">
              <h5
                id="title"
                class="text-white font-bold tracking-tight mb-2 text-base xl:text-4xl uppercase"
              >
                {article.title}
              </h5>
            </a>
            <p
              id="description"
              class="font-normal text-white mb-3 text-xs xl:text-xl"
            >
              {article.description}
            </p>
            <a
              class="text-white bg-main-color hover:bg-orange-dark focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-xs lg:text-sm px-3 py-2 text-center inline-flex items-center"
              href="#"
            >
              Read Article
            </a>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default Card3;
